<!-- ── Section Carte Google My Maps (avant le footer) ───────────────────── -->
<section id="arp-map"  class="arp-map-section" >
  <div class="container" *ngIf="shouldShow">

    <div class="arp-map-section__head wow fadeInUp" *ngIf="title || description">
      <h2 class="arp-map-section__title" *ngIf="title">{{ title }}</h2>
      <p class="arp-map-section__desc" *ngIf="description">{{ description }}</p>
    </div>
    @defer (on viewport) {
     <div class="arp-map-section__frame wow fadeInUp" data-wow-delay="100ms">
      <iframe
        *ngIf="safeMapUrl"
        [src]="safeMapUrl"
        title="Carte Google My Maps"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        allowfullscreen></iframe>
    </div>
    } @placeholder {
      <div class="home-skeleton home-skeleton--map" aria-hidden="true"></div>
    }
    

  </div>
</section>
